import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

import { AppSettings } from '~/core/models/appsettings';

const FILE = 'assets/appsettings.json';
const SETTINGS_KEY = '_AppSettings';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
  private http: HttpClient;

  constructor(private httpHandler: HttpBackend) {
    this.http = new HttpClient(this.httpHandler);
  }

  // Loads app settings from static JSON file and saves to session
  public async init(): Promise<boolean> {
    try {
      const data = await lastValueFrom(this.http.get<AppSettings>(FILE));

      await this.saveSettings(data);
      return true;
    } catch (error) {
      throw error;
    }
  }


  // Returns AppSettings from session or initializes if requested
  public async getSettings(initialize: boolean = false): Promise<AppSettings> {
    if (initialize) {
      await this.init();
    }

    const stored = sessionStorage.getItem(SETTINGS_KEY) ?? JSON.stringify(new AppSettings());

    return JSON.parse(stored);
  }

  // Saves AppSettings to session
  public saveSettings(settings: AppSettings): Promise<void> {
    if (!settings.roles) {
      settings.roles = [];
    }

    return new Promise<void>((resolve) => {
      sessionStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
      resolve();
    });
  }

  // Clears AppSettings from session
  public clearSettings(): void {
    sessionStorage.removeItem(SETTINGS_KEY);
  }
}
